import { DropDown, DropDownChoice } from '@vromo/ui';
import Input, { InputLabel } from '@vromo/ui/components/Input';
import { toUpper } from 'lodash';
import React from 'react';
import { CurrencyPicker } from '../../jobForm.style';
import styles from './orderValue.style';
import currencies from '../../currencies.json';
import { useTranslation } from 'react-i18next';
import { qaLabelDispatch } from '../../../../../common-qa-labels/dispatch';
import { buildDynamicLabel } from '../../../../../common-qa-labels/utils';
import { observer } from 'mobx-react-lite';

interface Props {
    orderValue: number;
    setOrderValue: (orderValue: number) => void;
    orderCurrency: string | undefined;
    setOrderCurrency: (orderCurrency: string | undefined) => void;
}

const OrderValue = observer(({ orderValue, setOrderValue, orderCurrency, setOrderCurrency }: Props) => {
    const { t } = useTranslation();

    return (
        <>
            <InputLabel optional label={t('job.orderValue')}></InputLabel>
            <div style={styles.contentContainer}>
                <CurrencyPicker>
                    {currencies[orderCurrency as keyof typeof currencies]?.symbol}
                </CurrencyPicker>
                <Input
                    data-testid={qaLabelDispatch.newJobModal.orderValueInput}
                    optional
                    value={orderValue || ''}
                    type="number"
                    step="0.01"
                    onChange={({ target: { value } }) => setOrderValue(value ? Number(value) : 0)}
                />
                <DropDown
                    data-testid={qaLabelDispatch.newJobModal.orderValueCurrencyDropdown}
                    menuStyle={styles.dropDownMenu}
                    button={<CurrencyPicker>{toUpper(orderCurrency)}</CurrencyPicker>}>
                    {Object.values(currencies).map(({ code }) => (
                        <DropDownChoice
                            data-testid={buildDynamicLabel(
                                qaLabelDispatch.newJobModal.orderValueCurrencyOption,
                                code
                            )}
                            key={code}
                            value={code}
                            current={orderCurrency || ''}
                            label={toUpper(code)}
                            onChange={(k: string) => setOrderCurrency(k)}
                        />
                    ))}
                </DropDown>
            </div>
        </>
    );
});

export default OrderValue;
